import {Divider} from "@mui/material";
import {Button} from "_ui/Button";
import {useStartAttendanceSession} from "_api/hooks/attendances";

export const StartSession = () => {
    const {mutateAsync: onClick, isPending: loading} = useStartAttendanceSession();

    return (
        <>
            Iniciar
            <Divider orientation='vertical' flexItem/>
            <Button icon='fa fa-play fa-bounce fs-2' {...{loading, onClick}}/>
        </>
    );
}
